import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface ISpecialType extends IBaseEntity {
    id?: number;
    description?: string;
    customerId?: number;
    locationPointId?: number;
    vehicleClassSpecialRates?: any[];
}

export class SpecialType extends BaseEntity implements ISpecialType {
    public id?: number;
    public description?: string;
    public customerId?: number;
    public locationPointId?: number;
    public vehicleClassSpecialRates?: any[];

    constructor(specialType?: any) {
        super();
        if (specialType) {
            this.id = specialType.id;
            this.description = specialType.description;
            this.customerId = specialType.customerId;
            this.locationPointId = specialType.locationPointId;
            this.vehicleClassSpecialRates = specialType.vehicleClassSpecialRates || [];
        }
    }

    get discriminator(): any {
        return this.description;
    }

    clone(): SpecialType {
        return new SpecialType(this);
    }
}
